<template>
	<div>
		<div v-if="!error && includedProduct">
			<TnBadge
				v-if="badgeText"
				class="margin-bottom-m"
				responsive
				>{{ badgeText }}</TnBadge
			>
			<div
				class="ecommerce-recommended-accessory"
				v-if="includedProduct"
			>
				<div class="image-wrapper">
					<NuxtImg
						height="150px"
						:src="includedProduct.imageLink"
					/>
				</div>
				<div class="accessory-details margin-left-m">
					<h2 class="accessory-details-header bold">{{ includedProduct.cleanName }}</h2>
					<p v-if="includedProduct.color">{{ includedProduct.color }}</p>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import ecommerceIntegration from "~/integrations/ecommerce-v2-integration";
export default defineNuxtComponent({
	name: "ECommerceIncludedProduct",

	props: {
		product: {
			type: Object,
		},
	},

	data: () => ({
		loading: false,
		includedProduct: null,
		error: null,
	}),

	computed: {
		includedItemId() {
			return (
				this.product?.campaignData?.attributes?.includedItem ||
				this.product?.campaignData?.attributes?.includeditem ||
				this.product?.memberPrice?.campaignData?.includedItem
			);
		},
		badgeText() {
			return this.product?.campaignData?.badges?.[0]?.text;
		},
	},

	watch: {
		includedItemId: {
			handler(id) {
				if (id && !this.includedProduct && !this.loading && !this.error) {
					this.fetchIncludedProduct();
				}
			},
			immediate: true,
		},
	},

	methods: {
		async fetchIncludedProduct() {
			this.loading = true;
			try {
				this.includedProduct = await ecommerceIntegration.getProductById(this.includedItemId);
			} catch (e) {
				this.error = true;
				console.error(e);
			} finally {
				this.loading = false;
			}
		},
	},
});
</script>
<style lang="scss" scoped>
.ecommerce-recommended-accessory {
	max-height: 150px;
	display: flex;

	.image-wrapper {
		height: auto;
		max-width: 40%;
		max-height: 150px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;

		img {
			object-fit: contain;
			width: 100%;
			max-height: 100px;
			max-width: 200px;
		}
	}

	h2 {
		margin-bottom: $spacing-m;

		@include font-title-m;
	}
}
</style>
